import { EditableStatus } from '@/main/utils/table';
import { DropdownItem } from '@/main/store/@types/dropdown.d';

export enum ScopeValueTypes {
	PASSWORD,
	EMAIL,
}

export interface AuthPracovnikInterface {
	Active: boolean;
	PracovnikId: number;
	Scope: string;
	ScopeValue: string;
	ScopeValueType: ScopeValueTypes | null;
}

export interface ScopeDropdownItem extends DropdownItem {
	ValueType: ScopeValueTypes;
}

export const types = <const>{
	mutations: {
		PRACOVNIK_NAKLADOVE_STREDISKO_SELECT_MAPPER: 'PRACOVNIK_NAKLADOVE_STREDISKO_SELECT_MAPPER',
	},
};

export type ProvozovnyType = {
	AktualizacePrp: boolean,
	ProvozovnaId: number,
	UpdateStatus: EditableStatus,

};
